export class GenerateTransferredItemsSeparationListReportInput {
  initialDate: string | null;
  finalDate: string | null;
  includeHeaders: boolean = true;
  returnStringData: boolean = false;
  locationId: number | null;
}